import { Constants, Enums } from "../../../utils";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";

const useViewModel = () => {
  const authLayoutRef = useRef({});
  const navigate = useNavigate();

  return {
    refs: { authLayout: authLayoutRef },
    onSignin: () => authLayoutRef.current.login.open(),
    onPurchase: () => navigate("/" + Enums.pagesNames.purchaseSubscription),
    onLearnMore: () =>
      window.open(Constants.Project.urls.alarmServices, "_blank"),
  };
};

export default useViewModel;
